import { SpinnerIcon } from '@ardoq/icons';
import { UIEventHandler, ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  display: block;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;
`;
LoadingOverlay.displayName = 'LoadingOverlay';

interface LoadingWrapperProps {
  loading?: boolean;
  style?: any;
  className?: string;
  onScroll?: UIEventHandler<HTMLDivElement>;
  children?: ReactNode;
}

export const LoadingWrapper = ({
  loading = false,
  children,
  ...props
}: LoadingWrapperProps) => (
  <Wrapper {...props}>
    {children}
    {loading && (
      <LoadingOverlay>
        <SpinnerIcon role="progressbar" />
      </LoadingOverlay>
    )}
  </Wrapper>
);
LoadingWrapper.displayName = 'LoadingWrapper';
